import { Component, Input, Output   } from '@angular/core'; 
import { NgxPaginationModule } from 'ngx-pagination';
import { UserService } from '../_Services/user.service';
import { CommonService } from '../_Services/common.service';
import { FormsModule, Validators, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';   

@Component({
  templateUrl: 'viewagency.component.html'
})
export class ViewagencyComponent {

    usefrs = [];  

    p: any = 1; 

    paginator = []; 
 

	constructor(private userService: UserService, private route:ActivatedRoute) { }
 
	pageChanged(page: Number) { 
		this.p = page;
		this.userService.getUsers(page).subscribe(result => {
                console.log(result.paginator);
                this.usefrs = result.data;
                this.paginator = result.paginator; 
            });  
	}
	ngOnInit() {  
		this.userService.getUsers(this.p).subscribe(result => {
                console.log(result);
                this.usefrs = result.data;
                this.paginator = result.paginator; 
            });  
	}
}




// WEBPACK FOOTER //
// ./src/app/users/viewagency.component.ts